/**
 * 회원가입 기업회원 소속 선택 (/m/signup/sosok) — 인증코드 또는 본사·지사·센터
 * ($j.Pages.Mobile.SignupSosok / body data-page-name="SignupSosok")
 */
export default class SignupSosok {
    initialize() {
        // centers: null = 아직 모름(지사 미선택·불러오는 중) / {} = 센터 없는 지사
        const state = { bonsa: null, gisa: '', center: '', centers: null, loading: false, samsung: false };
        const esc = (s) => $j.Common.Util.escapeHtml(s == null ? '' : String(s));
        let codeTimer = null;
        let lastCode = '';
        let busy = false;

        $(function () {
            $('#sosok-auth-code').on('input', function () {
                this.value = this.value.toUpperCase().replace(/\s/g, '');
                const code = this.value;
                clearTimeout(codeTimer);
                $('#sg-code-err').prop('hidden', true);
                // 본사코드 확인은 분당 5회로 제한된다 — 다 쳤을 때 한 번만 묻는다 (새 코드·옛 코드 A + 숫자 3자리 모두 4자리)
                if (code.length === 4) codeTimer = setTimeout(() => checkCode(code), 400);
            });

            $('#sg-code-reset').on('click', resetCode);
            $('#gisa-sel').on('change', onGisaChange);
            $('#center-sel').on('change', function () {
                state.center = this.value;
                updateNext();
            });
            $('#empcode').on('input', updateNext);
            $('#next-button').on('click', apply);

            window.addEventListener('pageshow', function (e) {
                if (e.persisted) busy = false;
            });

            updateNext();
        });

        /** 가입에 쓸 소속코드 — 센터가 있으면 센터(9자리), 없는 지사면 지사(6자리) */
        function sosokCode() {
            if (!state.gisa || state.loading || state.centers === null) return '';
            return Object.keys(state.centers).length ? state.center : state.gisa;
        }

        function updateNext() {
            let hint = '';
            if (!state.bonsa) hint = '인증코드를 입력해 주세요.';
            else if (!state.gisa) hint = '지사를 선택해 주세요.';
            else if (state.loading || state.centers === null) hint = '센터 목록을 불러오고 있어요.';
            else if (Object.keys(state.centers).length && !state.center) hint = '센터를 선택해 주세요.';
            else if (state.samsung && $('#empcode').val().trim().length < 8) hint = '사원번호를 8자리 이상 입력해 주세요.';

            $('#next-button').prop('disabled', !!hint);
            $('#sg-hint').text(hint);
        }

        function fillSelect($sel, list, placeholder) {
            const opts = [`<option value="">${esc(placeholder)}</option>`];
            $.each(list || {}, (code, name) => opts.push(`<option value="${esc(code)}">${esc(name)}</option>`));
            $sel.html(opts.join(''));
        }

        /**
         * 본사 인증코드 확인
         * @param code 회사에서 받은 인증코드
         */
        function checkCode(code) {
            if (code === lastCode) return;
            lastCode = code;

            $.getJSON('/m/ajax/bonsa/code', { d_code: code })
                .done(function (data) {
                    if ($('#sosok-auth-code').val() !== code) return;   // 응답 사이 코드가 바뀌었다
                    if (!data || !data.result) {
                        lastCode = '';   // 지웠다가 같은 코드를 다시 치면 또 알려 준다
                        showCodeError((data && data.message) || '올바르지 않은 코드입니다.');
                        return;
                    }
                    state.bonsa = { code: data.code, name: data.name || '' };
                    state.samsung = $j.Common.Util.isSosokSamsung(data.code);

                    $('#sg-bonsa-name').text(`${data.name || data.code} (${code})`);
                    $('#sg-code-field').prop('hidden', true);
                    $('#sg-bonsa, #sg-sosok').prop('hidden', false);
                    $('#samsung-emp-area').prop('hidden', !state.samsung);
                    fillSelect($('#gisa-sel'), data.list, '지사를 선택해 주세요');
                    resetGisa();
                    updateNext();
                })
                .fail(function (xhr) {
                    lastCode = '';
                    showCodeError(xhr && xhr.status === 429
                        ? '확인 요청이 많아요. 1분 뒤에 다시 입력해 주세요.'
                        : '코드를 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                });
        }

        function showCodeError(msg) {
            $('#sg-code-err').text(msg).prop('hidden', false);
        }

        /** [코드 변경] — 인증코드부터 다시 */
        function resetCode() {
            state.bonsa = null;
            state.samsung = false;
            lastCode = '';
            resetGisa();
            $('#gisa-sel').html('');
            $('#empcode').val('');
            $('#sg-bonsa, #sg-sosok, #samsung-emp-area').prop('hidden', true);
            $('#sg-code-field').prop('hidden', false);
            $('#sosok-auth-code').val('').trigger('focus');
            updateNext();
        }

        /** 지사를 바꾸면 이전 센터 선택은 버린다 */
        function resetGisa() {
            state.gisa = '';
            state.center = '';
            state.centers = null;
            state.loading = false;
            $('#center-sel').html('');
            $('#sg-center-field, #sg-center-none').prop('hidden', true);
        }

        function onGisaChange() {
            const gisa = this.value;
            resetGisa();
            state.gisa = gisa;
            if (!gisa) {
                updateNext();
                return;
            }

            state.loading = true;
            updateNext();
            $.getJSON('/ajax/sosok', { m: 'center', sosok: gisa })
                .done(function (list) {
                    if (state.gisa !== gisa) return;   // 그 사이 지사를 또 바꿨다
                    state.centers = (list && typeof list === 'object') ? list : {};
                    const has = Object.keys(state.centers).length > 0;
                    if (has) fillSelect($('#center-sel'), state.centers, '센터를 선택해 주세요');
                    $('#sg-center-field').prop('hidden', !has);
                    $('#sg-center-none').prop('hidden', has);
                })
                .fail(function () {
                    if (state.gisa !== gisa) return;
                    state.gisa = '';
                    $('#gisa-sel').val('');
                    $j.Common.Util.swalert('센터 목록을 불러오지 못했습니다. 지사를 다시 선택해 주세요.');
                })
                .always(function () {
                    if (state.gisa === gisa || !state.gisa) {
                        state.loading = false;
                        updateNext();
                    }
                });
        }

        function apply() {
            const code = sosokCode();
            if (busy || !code || $('#next-button').prop('disabled')) return;
            busy = true;

            $.ajax({
                type: 'POST',
                url: '/m/ajax/signup/sosok',
                dataType: 'json',
                data: { code, empcode: state.samsung ? $('#empcode').val().trim() : '' },
            })
                .done(function (data) {
                    if (data && data.result) {
                        location.replace('/m/signup/form');
                        return;
                    }
                    busy = false;
                    $j.Common.Util.swalert((data && data.message) || '소속을 저장하지 못했습니다. 다시 시도해 주세요.');
                })
                .fail(function (xhr) {
                    busy = false;
                    if (xhr && xhr.status === 403) {
                        $j.Common.Util.swalert('가입 진행 시간이 지났어요.\n처음부터 다시 진행해 주세요.',
                            function () { location.replace('/m/signup/agreement'); });
                        return;
                    }
                    $j.Common.Util.swalert('네트워크 오류로 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.');
                });
        }
    }
}
